export default String.raw`
<defs>
    <rect id="path-1" x="1" y="0" width="322" height="590"></rect>
    <filter x="-5.0%" y="-1.4%" width="109.9%" height="105.4%" filterUnits="objectBoundingBox" id="filter-2">
        <feOffset dx="0" dy="8" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
        <feGaussianBlur stdDeviation="4" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
        <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.3 0" type="matrix" in="shadowBlurOuter1"></feColorMatrix>
    </filter>
</defs>
<g id="06.-Lista-towarów" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <g id="Sidebar-Copy" transform="translate(7.000000, 0.000000)">
        <g id="Shadow">
            <use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1"></use>
            <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-1"></use>
        </g>
        <rect id="Rectangle" fill="#F6F6F6" x="0" y="0" width="323" height="590"></rect>
        <g id="More" transform="translate(0.000000, 505.000000)">
            <g class="primaryColorFont" transform="translate(286.000000, -10.000000)" fill-rule="nonzero">
                <use class="primaryColorFont--stroke" xlink:href="#angle-down" width="50" height="50" transform="scale(10)"></use>
            </g>
            <g id="Border" class="lightBorderColor--stroke">
                <line x1="0" y1="0.5" x2="320" y2="0.5" id="Line-3"></line>
            </g>
            <text id="Pozostałe" class="primaryColorFont" font-family="Roboto-Regular, Roboto" font-size="16" font-weight="normal">
                <tspan x="21" y="25">TRANSLATION_Prv_Other</tspan>
            </text>
        </g>
        <g id="Opinion" transform="translate(0.000000, 460.000000)">
            <g class="primaryColorFont" transform="translate(286.000000, -10.000000)" fill-rule="nonzero">
                <use class="primaryColorFont--stroke" xlink:href="#angle-down" width="50" height="50" transform="scale(10)"></use>
            </g>
            <g id="Border" class="lightBorderColor--stroke">
                <line x1="0" y1="0.5" x2="320" y2="0.5" id="Line-3"></line>
            </g>
            <text id="Ocena" class="primaryColorFont" font-family="Roboto-Regular, Roboto" font-size="16" font-weight="normal">
                <tspan x="21" y="25">TRANSLATION_Prv_Rating</tspan>
            </text>
        </g>
        <g id="Availability" transform="translate(0.000000, 415.000000)">
            <g class="primaryColorFont" transform="translate(286.000000, -10.000000)" fill-rule="nonzero">
                <use class="primaryColorFont--stroke" xlink:href="#angle-down" width="50" height="50" transform="scale(10)"></use>
            </g>
            <g id="Border" class="lightBorderColor--stroke">
                <line x1="0" y1="0.5" x2="320" y2="0.5" id="Line-3"></line>
            </g>
            <text id="Dostępność" class="primaryColorFont" font-family="Roboto-Regular, Roboto" font-size="16" font-weight="normal">
                <tspan x="21" y="25">TRANSLATION_Prv_AvailabilityA</tspan>
            </text>
        </g>
        <g id="Destination" transform="translate(0.000000, 370.000000)">
            <g class="primaryColorFont" transform="translate(286.000000, -10.000000)" fill-rule="nonzero">
                <use class="primaryColorFont--stroke" xlink:href="#angle-down" width="50" height="50" transform="scale(10)"></use>
            </g>
            <g id="Border" class="lightBorderColor--stroke">
                <line x1="0" y1="0.5" x2="320" y2="0.5" id="Line-3"></line>
            </g>
            <text id="Przeznaczenie" class="primaryColorFont" font-family="Roboto-Regular, Roboto" font-size="16" font-weight="normal">
                <tspan x="21" y="25">TRANSLATION_Prv_PrList_Target</tspan>
            </text>
        </g>
        <g id="Material" transform="translate(0.000000, 324.000000)">
            <g class="primaryColorFont" transform="translate(286.000000, -10.000000)" fill-rule="nonzero">
                <use class="primaryColorFont--stroke" xlink:href="#angle-down" width="50" height="50" transform="scale(10)"></use>
            </g>
            <g id="Border" class="lightBorderColor--stroke">
                <line x1="0" y1="0.5" x2="320" y2="0.5" id="Line-3"></line>
            </g>
            <text id="Materiał" class="primaryColorFont" font-family="Roboto-Regular, Roboto" font-size="16" font-weight="normal">
                <tspan x="21" y="25">TRANSLATION_Prv_ProductDetailsMaterialSelectorTitle</tspan>
            </text>
        </g>
        <g id="Company" transform="translate(2.000000, 279.000000)">
            <g class="primaryColorFont" transform="translate(286.000000, -10.000000)" fill-rule="nonzero">
                <use class="primaryColorFont--stroke" xlink:href="#angle-down" width="50" height="50" transform="scale(10)"></use>
            </g>
            <g id="Border" class="lightBorderColor--stroke">
                <line x1="0" y1="0.5" x2="320" y2="0.5" id="Line-3"></line>
            </g>
            <text id="Marka" class="primaryColorFont" font-family="Roboto-Regular, Roboto" font-size="16" font-weight="normal">
                <tspan x="21" y="25">TRANSLATION_Prv_ProductListFiltersMakes</tspan>
            </text>
        </g>
        <g id="Producent" transform="translate(2.000000, 234.000000)">
            <g class="primaryColorFont" transform="translate(286.000000, -10.000000)" fill-rule="nonzero">
                <use class="primaryColorFont--stroke" xlink:href="#angle-down" width="50" height="50" transform="scale(10)"></use>
            </g>
            <g id="Border" class="lightBorderColor--stroke">
                <line x1="0" y1="0.5" x2="320" y2="0.5" id="Line-3"></line>
            </g>
            <text class="primaryColorFont" font-family="Roboto-Regular, Roboto" font-size="16" font-weight="normal">
                <tspan x="21" y="25">TRANSLATION_Prv_ProductDetailsProducer</tspan>
            </text>
        </g>
        <g id="Colour" transform="translate(3.000000, 189.000000)">
            <g class="primaryColorFont" transform="translate(286.000000, -10.000000)" fill-rule="nonzero">
                <use class="primaryColorFont--stroke" xlink:href="#angle-down" width="50" height="50" transform="scale(10)"></use>
            </g>
            <g id="Border" class="lightBorderColor--stroke">
                <line x1="0" y1="0.5" x2="320" y2="0.5" id="Line-3"></line>
            </g>
            <text id="Kolor" class="primaryColorFont" font-family="Roboto-Regular, Roboto" font-size="16" font-weight="normal">
                <tspan x="21" y="25">TRANSLATION_Prv_ProductListFiltersColors</tspan>
            </text>
        </g>
        <g id="Price" transform="translate(21.000000, 90.000000)">
            <g id="Input/-Enabled" transform="translate(33.000000, 16.000000)">
                <rect id="Outline" class="inputsBgColor lightBorderColor--stroke" x="0.5" y="17.5" width="78" height="45"></rect>
                <text id="Label" font-family="Roboto-Regular, Roboto" font-size="13" font-weight="normal"></text>
            </g>
            <g id="Input/-Enabled" transform="translate(159.000000, 16.000000)">
                <rect id="Outline" class="inputsBgColor lightBorderColor--stroke" x="0.5" y="17.5" width="78" height="45"></rect>
                <text id="Label" font-family="Roboto-Regular, Roboto" font-size="13" font-weight="normal"></text>
            </g>
            <text id="Cena" font-family="Roboto-Regular, Roboto" font-size="16" font-weight="normal" fill="#000000">
                <tspan x="0" y="17">TRANSLATION_Prv_ProductListFiltersPrice</tspan>
            </text>
            <text id="od" font-family="Roboto-Regular, Roboto" font-size="16" font-weight="normal" fill="#000000">
                <tspan x="0" y="62">TRANSLATION_Prv_PrList_PriceFrom</tspan>
            </text>
            <text id="do" font-family="Roboto-Regular, Roboto" font-size="16" font-weight="normal" fill="#000000">
                <tspan x="126" y="62">TRANSLATION_Prv_PrList_PriceTo</tspan>
            </text>
            <text id="PLN" font-family="Roboto-Regular, Roboto" font-size="16" font-weight="normal" fill="#000000">
                <tspan x="252" y="62">zł</tspan>
            </text>
        </g>
        <g id="Filters-title" transform="translate(0.000000, 29.000000)">
            <rect id="Rectangle" class="primaryColor" x="0" y="0" width="4" height="40"></rect>
            <text id="Filtry" font-family="Roboto-Regular, Roboto" font-size="19" font-weight="normal" fill="#000000">
                <tspan x="19" y="27">TRANSLATION_Prv_PrList_FilterB</tspan>
            </text>
        </g>
        <g id="Button-/-Active" transform="translate(0.000000, 550.000000)">
            <rect id="Button-bg" class="btnSolidBgColor" x="0" y="0" width="323" height="40"></rect>
            <text id="Button-text" class="btnSolidTextColor" font-family="Roboto-Medium, Roboto" font-size="16" font-weight="400">
                <tspan x="130.136719" y="27">TRANSLATION_Prv_PrList_Set</tspan>
            </text>
        </g>
    </g>
</g>
`;